import { Text } from '@mantine/core';
import type { Phase } from '@flow/core';

const color: Record<Phase, string | undefined> = {
  ready: undefined,
  running: undefined,
  paused: 'var(--mantine-color-dimmed)',
  warn: 'var(--phase-warn)',
  critical: 'var(--phase-critical)',
  grace: 'var(--phase-grace)',
  over: 'var(--phase-over)',
};

/** Pure display: time + phase color. */
export const TimerDisplay = ({ label, phase, size = 28, testId }: { label: string; phase: Phase; size?: number; testId?: string }) => (
  <Text
    component="span"
    className="tabular"
    fw={700}
    data-testid={testId}
    data-phase={phase}
    style={{ fontSize: size, lineHeight: 1, color: color[phase], fontFamily: 'var(--mantine-font-family-monospace)', letterSpacing: '-0.02em' }}
  >
    {label}
  </Text>
);
